import {ADDITIONAL_SSX_AVATAR_MODELS} from './ssx-avatar-presets.mjs';
/** Native avatar descriptors. Pure metadata, with no renderer or loading side effects. */
export const AVATAR_MODELS=Object.freeze([
  Object.freeze({value:'female',label:'Female',file:'valoria-scout.glb',revision:'anime-248749a87a91'}),
  Object.freeze({value:'male',label:'Male',file:'valoria-metro-male.glb',revision:'anime-e9b99893a01d'}),
  Object.freeze({value:'valor',label:'Valor',file:'valoria-valor.glb',revision:'anime-8e9966b55abb'}),
  Object.freeze({value:'zoe',label:'Zoe',file:'valoria-zoe.glb',revision:'zoe-7c28ab41ece2'}),
  ...ADDITIONAL_SSX_AVATAR_MODELS,
]);
export const avatarPreset=value=>AVATAR_MODELS.some(model=>model.value===value)?value:'female';
